// src/utils/styles.js
export const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: 'rgba(31, 36, 60, 0.6)',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        color: '#e2e8f0',
        minHeight: '42px',
        boxShadow: 'none',
        '&:hover': {
            borderColor: 'rgba(212, 184, 134, 0.5)', // stardust-gold
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#1a1d2e', // hsr-panel
        border: '1px solid rgba(255, 255, 255, 0.1)',
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#e2e8f0',
    }),
    input: (provided) => ({
        ...provided,
        color: '#e2e8f0',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#3d4566'
            : state.isFocused
                ? 'rgba(255, 255, 255, 0.1)'
                : 'transparent',
        color: '#e2e8f0',
        cursor: 'pointer',
        '&:active': {
            backgroundColor: '#3d4566',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#9ca3af', // gray-400
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),
};
